import React, { useEffect } from 'react';

import { useEthers } from '@usedapp/core';

import Loader from '@bitcoin-portal/verse-web-components/dist/Loader';

import Divider from '@components/Divider';
import SEO from '@components/SEO';

import { useIsLoading } from '@hooks/useIsLoading';
import useTrackEvent from '@hooks/useTrackEvent';

import { useLoungeAccess } from '@views/Lounge/hooks/useLoungeAccess';
import { useValidNetwork } from '@views/Lounge/hooks/useValidNetwork';

import Community from './Community';
import Discounts from './Discounts';
import Header from './Header';
import InvalidNetwork from './InvalidNetwork';
import NoVerse from './NoVerse';
import NoWallet from './NoWallet';
import Partners from './Partners';
import { ContentWrapper, SpinnerWrapper } from './styled';

const Lounge = () => {
  const { account } = useEthers();

  const meetsLoungeCriteria = useLoungeAccess();
  const invalidNetwork = useValidNetwork();
  const isLoading = useIsLoading();
  const trackEvent = useTrackEvent();

  useEffect(() => {
    if (!isLoading) {
      trackEvent('verseLoungeVisited');
    }
  }, [isLoading]);

  return isLoading ||
    (account !== undefined && meetsLoungeCriteria === undefined) ? (
    <>
      <SEO page="lounge" />
      <SpinnerWrapper>
        <Loader />
      </SpinnerWrapper>
    </>
  ) : (
    <>
      <SEO page="lounge" />
      <Header
        connected={!!account && !invalidNetwork && !!meetsLoungeCriteria}
      />
      <ContentWrapper>
        {!invalidNetwork && meetsLoungeCriteria && (
          <>
            <Community />
            <Divider />
            <Discounts />
            <Divider />
            <Partners />
          </>
        )}
        {!!account && !invalidNetwork && !meetsLoungeCriteria && <NoVerse />}
        {invalidNetwork && <InvalidNetwork />}
        {!account && <NoWallet />}
      </ContentWrapper>
    </>
  );
};

export default Lounge;
